import { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { DatePipe, formatDate } from '@angular/common';
import { RatesQueryDetailsReportService } from 'src/app/services/rates-query-details-report/rates-query-details-report.service';
import { LoadingService } from 'src/app/services/loading/loading.service';
import { AlertService } from 'src/app/services/alert/alert.service';

@Component({
    selector: 'app-hhg-rates-query-report',
    templateUrl: './hhg-rates-query-report.component.html',
    standalone: false
})
  export class HhgRatesQueryReportComponent implements OnInit{
      results: any;
      tempResults: any;
      startDate: any;
      endDate: any;
      filterGroup: UntypedFormGroup;
      itemsPerPage = 10;
      format = 'MM/dd/yyyy';
      locale = 'en-US';
      messageColumnDefs=[
        {
          headerName:'Query Type',
          field:'queryType',
          width: 120
        },
        {
          headerName:'Query Date',
          field:'queryDate',
          valueGetter: (params) => {
            return params.data.queryDate ? (formatDate(params.data.queryDate , this.format, this.locale)) : 'Not Available';
          },
          width: 120
        },
        {
          headerName:'Pick Up Date',
          field:'pickupDate',
          valueGetter: (params) => {
            return params.data.pickupDate ? (formatDate(params.data.pickupDate , this.format, this.locale)) : 'Not Available';
          },
          width: 120
        },
        {
          headerName:'Origin City/State/Zip',
          field:'originCityStateZip',
          width: 200
        },
        {
          headerName:'Origin Country',
          field:'originCountry',
          width: 200
        },
        {
          headerName:'Dest City/State/Zip',
          field:'destCityStateZip',
          width: 200
        },
        {
          headerName:'Dest Country',
          field:'destCountry',
          width: 200
        },
        {
          headerName:'Miles',
          field:'miles',
          width: 100
        },
        {
          headerName:'Agency Name',
          field:'agencyName',
          width: 200
        },
        {
          headerName:'Bureau',
          field:'bureauName',
          width: 250
        },
        {
          headerName:'Location ID',
          field:'locationCode',
          width: 100
        },
        {
          headerName:'RO Email',
          field:'roEmail',
          width: 200
        },
        {
          headerName:'RO First Name',
          field:'roFirstName',
          width: 200
        },
        {
          headerName:'RO Last Name',
          field:'roLastName',
          width: 200
        },
        {
          headerName:'User Email',
          field:'userEmail',
          width: 200
        },
        {
          headerName:'User FAIC',
          field:'faic',
          width: 200
        },
        {
          headerName:'SRO Id',
          field:'sroId',
          width: 100
        },
        {
          headerName:'Rate Type',
          field:'rateType',
          width: 100
        },
        {
          headerName:'Estimated Weight',
          field:'estimatedWeight',
          width: 150
        },
        {
          headerName:'Base Trans Cost',
          field:'baseTransCost',
          width: 150
        }
      ];
      domLayout;

      constructor(private service:RatesQueryDetailsReportService,
        private datepipe: DatePipe,
        private alertService: AlertService,
        private tmssLoader: LoadingService,
        private fb: UntypedFormBuilder){
    
        
      }
      ngOnInit() {
        this.domLayout = 'autoHeight';
        this.generateFormGroupController();
        this.getRateDetails();

      }

      getRateDetails(){
        this.tmssLoader.show();
        this.service.getRatesQueryDetails("HHG").subscribe(res => {
          this.results = res;
          this.tmssLoader.hide();
      },error => {
        this.alertService.error("There was an error while fetchihng rate query details.");
        this.tmssLoader.hide();
      }
      )
      }
      generateFormGroupController() {
        this.filterGroup = this.fb.group({
          fromDate: new UntypedFormControl(null,Validators.required),
          toDate: new UntypedFormControl(null,Validators.required),
        },{
          validators: [createDateRangeValidator()]
        });
      }

      searchByFilter(){
        this.tmssLoader.show();
        this.service.getRatesQueryDetailsByDate("HHG", this.startDate, this.endDate).subscribe(res => {
          this.results = res;
          this.tmssLoader.hide();
        },error => {
          this.alertService.error("There was an error while fetchihng rate query details.");
          this.tmssLoader.hide();
        }
      );
     }

      filterToDateChange(event){
        this.endDate = this. datepipe. transform(event, 'yyyy-MM-dd');
        this.results = [];
      }

      filterFromDateChange(event){
        this.startDate = this. datepipe. transform(event, 'yyyy-MM-dd');
        this.results = [];
       }

    }

    function createDateRangeValidator(): ValidatorFn {
      return (form: UntypedFormGroup): ValidationErrors | null => {
    
        const start:Date = form.get("fromDate").value;
    
        const end:Date = form.get("toDate").value;
    
        if (start && end) {
             const isRangeValid = !(end.getTime() < start.getTime());
    
            return isRangeValid ? null : {dateRange:true};
        }
    
        return null;
      }
    }